export default __webpack_public_path__ + "static/media/sts-7.1fb573b1.png";